<template>
  <div class="url-form-container">
    <el-card class="form-card" shadow="hover">
      <template #header>
        <div class="card-header">
          <el-icon><Link /></el-icon>
          <span>直播间信息设置</span>
        </div>
      </template>
      
      <el-form 
        ref="urlFormRef" 
        :model="urlForm" 
        :rules="formRules" 
        label-width="120px"
        class="url-form"
      >
        <!-- 直播房间号 -->
        <el-form-item label="直播房间号" prop="Live_streaming_room">
          <el-input 
            v-model="urlForm.Live_streaming_room" 
            placeholder="请输入直播房间号"
            @keyup.enter="submitForm"
          />
        </el-form-item>
        
        <!-- 主页URL -->
        <el-form-item label="主页URL" prop="Home_Page">
          <el-input 
            v-model="urlForm.Home_Page" 
            placeholder="请输入主页URL"
            @keyup.enter="submitForm"
          />
        </el-form-item>
        
        <!-- AFDian链接 -->
        <el-form-item label="爱发电主页" prop="afd">
          <el-input 
            v-model="urlForm.afd" 
            placeholder="请输入爱发电主页"
            @keyup.enter="submitForm"
          />
        </el-form-item>
        
        <!-- 操作按钮 -->
        <el-form-item style="text-align: center; margin-top: 20px;">
          <el-button 
            type="primary" 
            :loading="submitLoading"
            @click="submitForm"
          >
            提交
          </el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import { Link } from '@element-plus/icons-vue';

// 表单引用
const urlFormRef = ref(null);

// 表单数据
const urlForm = reactive({
  Live_streaming_room: '',
  Home_Page: '',
  afd: ''
});

// 表单验证规则
const formRules = reactive({
  Live_streaming_room: [
    { required: true, message: '请输入直播房间号', trigger: 'blur' },
  ],
  Home_Page: [
    { required: true, message: '请输入主页URL', trigger: 'blur' },
  ],
});

// 提交状态
const submitLoading = ref(false);

// 提交表单
const submitForm = () => {
  urlFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        submitLoading.value = true;
        
        // 发送POST请求
        const response = await axios.post('/adminapi/url/updata', {
          Live_streaming_room: urlForm.Live_streaming_room,
          Home_Page: urlForm.Home_Page,
          afd: urlForm.afd
        });
        
        // 处理响应
        if (response.data && response.data.code === 200) {
          ElMessage.success('信息更新成功');
          fetchFormData();
        } else {
          ElMessage.error(response.data.message || '提交失败，请重试');
        }
      } catch (error) {
        console.error('提交错误:', error);
        ElMessage.error('网络错误，请检查连接');
      } finally {
        submitLoading.value = false;
      }
    } else {
      ElMessage.error('请检查表单输入');
      return false;
    }
  });
};

// 重置表单
const resetForm = () => {
  urlFormRef.value.resetFields();
};


// 获取表单数据
const fetchFormData = async () => {
  try {
    const response = await axios.get('/adminapi/userapi/url/list');
    // console.log(response.data.results[0])
      // 更新表单数据
      urlForm.Live_streaming_room = response.data.results[0]?.Live_streaming_room || '';
      urlForm.Home_Page = response.data.results[0]?.Home_Page || '';
      urlForm.afd = response.data.results[0]?.afd || '';

  } catch (error) {
    console.error('加载错误:', error);
    ElMessage.error('网络错误，请检查连接');
  }
};

onMounted(() => {
  // 初始化焦点到直播房间号输入框
  const roomInput = document.querySelector('el-input[placeholder="请输入直播房间号"] input');
  if (roomInput) {
    roomInput.focus();
  }
  fetchFormData();
});
</script>

<style lang="scss" scoped>
.url-form-container {
  padding: 30px;
  max-width: 800px;
  margin: 0 auto;
  
  .form-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }
  }
  
  .card-header {
    display: flex;
    align-items: center;
    color: #303133;
    font-size: 18px;
    font-weight: 500;
    
    .el-icon {
      margin-right: 10px;
      color: #409eff;
    }
  }
  
  .url-form {
    .el-form-item {
      margin-bottom: 20px;
    }
    
    .el-input {
      &::v-deep {
        .el-input__inner {
          border-radius: 4px;
          transition: border-color 0.3s, box-shadow 0.3s;
        }
        
        &:focus-within .el-input__inner {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
      }
    }
  }
}
</style>